<template>
    <vuestic-modal ref="deleteModal" :cancelClass="'none'" :okClass="'none'">
      <div slot="title">Do you want to delete?</div>
      <vuestic-alert type="danger">
        <span class="badge badge-pill badge-danger">Danger!</span>
        You will not be able to reverse this action!
      </vuestic-alert>
      <button class="btn btn-secondary btn-micro" @click="hideDeleteModal()">
        CANCEL
      </button>
      <button class="btn btn-danger btn-micro" @click="deleteContact()">
        DELETE
      </button>
    </vuestic-modal>
  </div>
</template>

<script>
  import axios from 'axios'
  import store from '../../../store'
  export default {
    name: 'delete-object',
    props: {
      showDefinition: {
        type: Object,
        default: () => {}
      },
      client: {
        type: Object
      }
    },
    data: function () {
      return {
        urls: this.showDefinition.urls,
        object: {},
        id: this.$route.params.id
      }
    },
    methods: {
      deleteContact () {
        store.commit('setLoading', true)
        const self = this
        self.$refs.deleteModal.cancel()
        const path = `${this.urls.deleteObject.url}`
        const id = self.id ? self.id : null
        const url = self.client.methods.api_url(path, id)
        let options = self.client.methods.api_options()
        axios[this.urls.deleteObject.method](url, options)
        .then(function (response) {
          store.commit('setLoading', false)
          self.$router.go(-1)
        })
        .catch(function (error) {
          console.log(error)
          store.commit('setLoading', false)
          if (error.response.status === 401) {
            self.$router.push({ name: 'Logout' })
          }
        })
      },
      openDeleteModal () {
        this.$refs.deleteModal.open()
      },
      hideDeleteModal () {
        this.$refs.deleteModal.cancel()
      }
    }
  }
</script>
<style>
  td.key {
  text-transform: uppercase;
  font-weight: 500;
  }

  .object-table th, .object-table td {
  min-width: 120px;
  padding: 10px 20px;
  }

  .form-group1 {
    margin: 0 0 0 0;
  }

  .form-group1 input {
    border: 1px solid black;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/fractel/components/objects/Delete.vue